import { Component, forwardRef } from '@angular/core';
import { ModifierListAbstract } from '../modifier-list.abstract';
import { ModifierItem } from '../modifier-item.interface';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ItemModifier } from '../../../api/v1/models/item-modifier';

@Component({
  selector: 'app-group-modifiers',
  templateUrl: './group-modifiers.component.html',
  styleUrls: ['./group-modifiers.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupModifiersComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GroupModifiersComponent),
      multi: true,
    }
  ]
})
export class GroupModifiersComponent extends ModifierListAbstract<ModifierItem>  {
  constructor () {
    super();
  }

  static nextId = 0;
  groupName = `item_${GroupModifiersComponent.nextId++}`;

  /*
  * formGroup - хранит внешний формат ответа
  * formControl используется для внутренней работы радиокнопок
  * */
  formGroup = this.getFormItem();
  formControl = new FormControl<string | null>(null);

  onChangeCount(item: ItemModifier): void {
    this.formGroup.controls.name.setValue(item.name);
    this.formGroup.controls.sku.setValue(item.sku);
    this.formGroup.controls.prices.setValue(item.prices);
    this.formGroup.controls.quantity.setValue(1);
    this.formGroup.controls.freeQuantity.setValue(this.isNotFree(item, item.prices[0].price) ? 0 : 1);
    this.update();
  }

  override writeFormValue (formData: ModifierItem[]): void {
    if(formData && formData.length && formData[0].quantity) {
      const activeItemIndex = this.items.findIndex(item => item.sku === formData[0].sku);
      if(this.isCheckDisabledItem(activeItemIndex)) {return}

      this.formControl.setValue(formData[0].sku);
      this.formGroup.patchValue(formData[0]);
    }
    this.formGroup.controls.itemGroupId.setValue(formData[0].itemGroupId)
  }

  override getFormData (): ModifierItem[] | null {
    const value = this.formGroup.getRawValue();
    return value.quantity ? [value] : null;
  }

  isNotFree(item: ItemModifier, price: number | null | undefined): boolean {
    const groupFreeQuantity = this.modifierGroup.restrictions.freeQuantity;
    return this.isCheckMinMaxRestrictions
      ? !!price && item.balance !== 0 && (item.restrictions.freeQuantity === 0 || groupFreeQuantity === 0)
      : !!price && item.balance !== 0 && groupFreeQuantity === 0;
  }
}
